import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';

import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

import ReactSummernote from 'react-summernote';
import 'react-summernote/dist/react-summernote.css'; 
import 'react-summernote/lang/summernote-ko-KR';

import { Panel, PanelHeader, PanelBody } from '../../../components/admin/panel/panel';
import { boardsActions } from '../../../store/boards';
import { pageTitle } from '../../../helpers/page-admin';

class Update extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...this.props.history.location.state,
            deleteFileIds: []
        }

        for (var key in this.state) {
            if (this.state[key] === 'null') this.state[key] = null;
            if (key === 'formFiles') this.state.formFiles = [];
        }
    }

    async onSubmit(event) {
        event.preventDefault();
        //const { boardId, category, subCategory, userId, name, title, hit } = this.state;
        //if (boardId && category && subCategory && userId && name && title && hit) {
        const { boardId, category, subCategory, title, time, hit } = this.state;
        //console.log(time);
        if (boardId && category && subCategory && title && time && hit) {
            await this.props.putBoard(boardId, this.state);
            await this.props.history.push(`/admin/boards/${category}/${subCategory}`);
        } else this.setState({ submitted: true });
    };

    onChange(event) {
        const { name, value } = event.target;
        //console.log(value);
        this.setState({ [name]: value });
    };

    onChangeDateTime(date) {
        // 2012-05-21 17:18:00.0000000
        // 2019-04-02 10:38:00.0000000
        if (date._d === undefined || date._d.toString().length !== 42) return;
        const time = moment(date._d).format("YYYY-MM-DD hh:mm:ss") + ".0000000";
        this.setState({ time: time });
    }

    onChangeFile(event) {
        let file = event.target.files[0] ? event.target.files[0] : null;
        if (file === null) return;

        const type = event.target.attributes.getNamedItem('data-type').value;
        file.typeOfStorage = type;
        let { formFiles } = this.state;

        // 삭제될 파일 ID 등록
        const self = this;
        this.state.files.forEach(function (item) {
            if (self.state.files.length !== self.state.deleteFileIds.length && item.type === type) {
                self.state.deleteFileIds.push(item.fileId);
            }
        });

        let hasFile = false;
        for (let i = 0; i < formFiles.length; i++) {
            if (formFiles[i].typeOfStorage === type) {
                hasFile = true;
                formFiles[i] = file;
                this.setState({ formFiles: formFiles });
            }
        }
        if (!hasFile) {
            this.setState({ formFiles: formFiles.concat(file) });
        }
    };

    onChangeNote(content) {
        this.setState({ content: content });
    };

    onImageUpload(images, insertImage) {
        for (let i = 0; i < images.length; i++) {
            const reader = new FileReader();
            reader.onloadend = () => {
                insertImage(reader.result, function ($image) {
                    $image.addClass('img-fluid');
                });
            };
            reader.readAsDataURL(images[i]);
        }
    };

    render() {
        const { title, time, hit, submitted } = this.state;
        //console.log(this.state);

        return (
            <div>
                <h1 className="page-header">{pageTitle(this.state.category, this.state.subCategory).title}</h1>
                <Panel>
                    <PanelHeader>수정</PanelHeader>
                    <PanelBody>
                        <form onSubmit={(e) =>this.onSubmit(e)} encType="multipart/form-data" method="post">
                            <div className="form-group">
                                <label className="control-label">제목</label>
                                <input onChange={(e) => this.onChange(e)} name="title" className="form-control" value={this.state.title} />
                                {submitted && !title && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label className="control-label">등록일</label>
                                        {/*
                                        <DateTime onChange={(e) => this.onChangeDateTime(e)}
                                            defaultValue={moment(this.state.time).format("YYYY-MM-DD hh:mm:ss")}
                                            dateFormat="YYYY-MM-DD hh:mm:ss" timeFormat={false}
                                            inputProps={{ placeholder: 'Datepicker' }}
                                            closeOnSelect={true} />
                                        */}
                                        <input onChange={(e) => this.onChange(e)} name="time" className="form-control" value={this.state.time}  />
                                        
                                        {submitted && !time && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label className="control-label">조회수</label>
                                        <input onChange={(e) => this.onChange(e)} name="hit" className="form-control" value={this.state.hit}  />
                                        {submitted && !hit && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                                    </div>
                                </div>
                            </div>


                            {/* 자료실, 현장스케치, 사서냥이의 하루 ==> 제외 */}
                            {this.state.subCategory !== 'newsletter' && this.state.subCategory !== 'sniffleader' && this.state.subCategory !== 'scene' && this.state.subCategory !== 'day' &&
                                <div>

                                    <div className="form-group">
                                        <label className="control-label">요약글</label>
                                        <textarea onChange={(e) => this.onChange(e)} name="summary" className="form-control" rows="3" defaultValue={this.state.summary}></textarea>
                                    </div>
                            
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group p-t-10">
                                                <label className="control-label">섬네일 이미지</label>
                                                <input onChange={(e) => this.onChangeFile(e)} name="formfiles" className="form-control-file" data-type="thumbnails" type="file" />
                                                {this.state.subCategory !== 'resource' &&
                                                    <small className="text-muted g-font-size-11">Note: 용량: 2M 이하 사이즈: 400 X 250</small>
                                                }
                                                {this.state.subCategory === 'resource' &&
                                                    <small className="text-muted g-font-size-11">Note: 용량: 2M 이하 사이즈: 180 X 240</small>
                                                }
                                                {this.state.files.map(function (file) {
                                                    if (file.type === 'thumbnails') {
                                                        return (<p key={file.fileId} className="m-b-0 m-r-15">{file.fileName}</p>)
                                                    }; return null;
                                                })}
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="form-group p-t-10">
                                                <label className="control-label">첨부파일 1</label>
                                                <input onChange={(e) => this.onChangeFile(e)} className="form-control-file" data-type="attachments" type="file" />
                                                <small className="text-muted g-font-size-11">Note: 용량: 2M 이하</small>
                                                {this.state.files.map(function (file) {
                                                    if (file.type === 'attachments') {
                                                        return (<p key={file.fileId} className="m-b-0 m-r-15">{file.fileName}</p>)
                                                    }; return null;
                                                })}
                                            </div>
                                    </div>

                                    </div>
                                </div>
                            }

                            {/* 현장스케치, 사서냥이의 하루 ==> 제외 */}
                            {this.state.subCategory !== 'scene' && this.state.subCategory !== 'day' &&
                                <div>
                                    <label className="control-label">내용</label>
                                    <ReactSummernote
                                        value={this.state.content === 'null' ? '' : this.state.content}
                                        options={{
                                            lang: 'ko-KR',
                                            height: 500,
                                            dialogsInBody: true,
                                            focus: true,
                                            toolbar: [
                                                ['style', ['style']],
                                                ['font', ['bold', 'underline', 'clear']],
                                                ['fontname', ['fontname']],
                                                ['para', ['ul', 'ol', 'paragraph']],
                                                ['table', ['table']],
                                                ['insert', ['link', 'picture', 'video']],
                                                ['view', ['fullscreen', 'codeview']]
                                            ]
                                        }}
                                        onChange={(content) => this.onChangeNote(content)}
                                        onImageUpload={this.onImageUpload}
                                    />
                                </div>
                            }

                            <div className="form-group text-right p-t-15">
                                <Link to={`/admin/boards/${this.state.category}/${this.state.subCategory}`} className="btn btn-success rounded-0 m-r-5">목록</Link>
                                <button type="submit" className="btn btn-inverse rounded-0">등록</button>
                            </div>

                        </form>

                    </PanelBody> 
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => ({ boards: state.boards }),
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Update));


// WEBPACK FOOTER //
// ./src/pages/admin/boards/update.js